export const shared = {
  toggleLocale: 'العربية',
  view: 'View',
  edit: 'Edit',
  delete: 'Delete',
  confirm: 'Confirm',
  cancel: 'Cancel',
  send: 'Send',
  add: 'Add',
  download: 'Download',
  notFound: 'Not Found',
  networkError: 'Network Error',
  noData: 'No Data Found',
  generalErrMsg: 'Something went wrong!',
  save: 'Save',
  fileSize: 'File Size',
  copyPhoneNumber: 'Copy phone number',
  copied: 'Copied',
  appBar: {
    logout: 'Logout',
    search: 'Search…',
    filters: 'Filters',
    block: 'Block',
    unblock: 'Unblock',
    select: 'Select',
    import: 'Import',
    reorder: 'Reorder',
    reorderHint: 'Reordering is done by drag & drop.',
    reorderAlert: 'You must clear any filter or search to reorder.',
  },
  drawer: {
    users: 'Users',
    singleOwners: 'Single Owners',
    fleetOwners: 'Fleet Owners',
    drivers: 'Drivers',
    rewards: 'Rewards',
    liveRewards: 'Live Rewards',
    deletedRewards: 'Deleted Rewards',
    trips: 'Trips',
    tripsDrivers: 'Drivers Trips',
    tripsOwners: 'Owners Trips',
    pendingDrivers: 'Pending Drivers',
    verificationRequests: 'Verification Requests',
    pendingRequests: 'Pending Request',
    requestsHistory: 'Requests History',
    adminsManagement: "Admins' Management",
    standardAdmins: 'Standard Admins',
    referralProgram: 'Referral Program',
    referralsList: 'Referrals List',
    referralsRewards: 'Referral Rewards',
    offers: 'Offers',
    animations: 'Animations',
    services: 'Services',
    serviceCenters: 'Service Centers',
    marketplace: 'Marketplace',
    challenges: 'Challenges',
    chat: 'Chat',
  },
  filters: {
    noOptions: 'No options',
    startDate: 'Start date',
    endDate: 'End date',
    clear: 'Clear',
    loading: 'Loading…',
    from: 'From',
    to: 'To',
  },
  upload: {
    cropBanner: 'Crop Banner',
    done: 'Done',
    sizeError: 'This image exceeds maximum size (1MB)',
    sizeErrorFiveMb: 'This image exceeds maximum size (5MB)',
    typeError: 'This image is not of accepted types',
    uploadBanner: 'Upload Banner',
    sizeHint: 'Max size: 15MB',
    typeHint: 'Files supported: JPG, PNG, JPEG',
    cropImg: 'Crop Image',
    excelTypeHint: 'Files supported: XLSX',
    jsonTypeHint: 'Files supported: JSON',
    fileSizeError: 'This file exceeds maximum size (1MB)',
    fileTypeError: 'This file is not of accepted types',
    invalidAnimationFile: 'Invalid Animation File',
    halfMBFileSizeError: 'This file exceeds maximum size (0.5MB)',
    invalidJSONFileFormat: 'Invalid JSON File',
  },
  exportPdf: 'Export PDF',
  startLocation: 'Start Location',
  endLocation: 'End Location',
  selectActions: 'Select Actions',
  update: 'Update',
  proceed: 'Proceed',
  close: 'Close',
  invalidAnimationFile: 'Invalid Animation File',
  yes: 'Yes',
  no: 'No',
  redFlag: {
    columnHeader: 'Red Flag',
    flagAction: 'Flag as Fraud',
    removeAction: 'Remove Flag',
    flagTitle: 'Flag this user as fraud',
    flagBody: '{name} will be marked as fraudulent across the platform.',
    unflagTitle: 'Remove fraud flag',
    unflagBody: '{name} will no longer be marked as fraudulent.',
    reasonPlaceholder: 'Reason for flagging (optional)...',
    source: {
      ai: 'AI',
      backend_rule: 'System Rule',
      manual: 'Manual',
    },
  },
};
